/**
 * One-shot purge of the RETIRED WebGL constellation's position cache.
 *
 * The old `/map` persisted dragged layouts under
 * `syncanix:map:constellation:*`, whose keys embed the customer's route +
 * endpoint inventory as node ids — the F26 privacy finding. The atlas keeps
 * dragged positions in memory only, so nothing writes these keys any more;
 * this sweep exists so a browser that USED the old build does not carry that
 * residue forever. Runs at shell boot (cheap: one prefix scan), touches
 * nothing else in storage.
 */
const LEGACY_PREFIX = 'syncanix:map:constellation:';

export function purgeLegacyMapCache(
  storage: Pick<Storage, 'key' | 'length' | 'removeItem'> | null = safeLocalStorage(),
): void {
  if (storage === null) return;
  const doomed: string[] = [];
  for (let i = 0; i < storage.length; i++) {
    const key = storage.key(i) ?? '';
    if (key.startsWith(LEGACY_PREFIX)) doomed.push(key);
  }
  for (const key of doomed) storage.removeItem(key);
}

function safeLocalStorage(): Storage | null {
  try {
    return typeof window === 'undefined' ? null : window.localStorage;
  } catch {
    // Privacy modes can throw on ACCESS; a browser that blocks storage has no
    // residue to purge.
    return null;
  }
}
